import React, { useState } from 'react';
import { Layout, Menu, Typography, Tooltip, Button } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { useNavigate, useLocation } from 'react-router-dom';
import './AppSidebar.css';
import { ConfigurationDisplayDto } from '../../../services/ApiTypes';

const { Sider } = Layout;
const { Text } = Typography;
interface SidebarProps {
  configurationDisplays: ConfigurationDisplayDto[];
} 

const SidebarComponent: React.FC<SidebarProps> = ({ configurationDisplays }) => {
  const [collapsed, setCollapsed] = useState(false);
  const location = useLocation();
  const selectedKeyFromPath = location.pathname.split('/')[2];
  const selectedKeys = selectedKeyFromPath ? [selectedKeyFromPath] : [];
  const navigate = useNavigate();

  const handleMenuClick = (key: string) => {
    navigate(`configuration/${key}`);
  };
  const handleAddButtonClick = () => {
    navigate(`configuration/`);
  };

  return (
    <Sider
      width={'300px'}
      collapsed={collapsed}
      onCollapse={(collapsed) => setCollapsed(collapsed)}
      className="custom-sider"
    >
      <div className="sidebar-content">
        <Text strong className='custom-sidebar-title'>
          Configurations
        </Text>
        <Tooltip title="New Configuration">
          <Button
            className='custom-sidebar-add-button'
            size="small"
            type="primary"
            shape="circle"
            icon={<PlusOutlined />}
            onClick={handleAddButtonClick}
          />
        </Tooltip>
        <Menu
          mode="inline"
          selectedKeys={selectedKeys}
          onClick={({ key }) => handleMenuClick(key)}
          items={configurationDisplays.map((config: ConfigurationDisplayDto) => ({
            key: config.id,
            label: (
              <div className="menu-item-row">
                <Tooltip title={config.displayName}>
                  <span className="menu-item-label">{config.displayName}</span>
                </Tooltip>
              </div>  
            ),
          }))}
        />
      </div>
    </Sider>
  );
};

export default SidebarComponent;
